module.exports = __webpack_public_path__ + "img/chat-right-text-fill.ffd7ff04.svg";